import { Phone, MessageSquare } from "lucide-react";
import { BRAND } from "@/lib/brand";

export default function MobileBar() {
  return (
    <div className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-cream/95 backdrop-blur-md border-t-2 border-charcoal px-4 py-3 flex gap-3" style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }} data-testid="mobile-call-bar">
      <a href={BRAND.phoneHref} data-testid="mobile-call-link"
        className="flex-1 inline-flex items-center justify-center gap-2 bg-coral text-cream font-heading font-bold rounded-full py-3 border-2 border-charcoal shadow-brutsm">
        <Phone className="w-5 h-5" /> Call
      </a>
      <a href={BRAND.smsPhotoHref} data-testid="mobile-text-link"
        className="flex-1 inline-flex items-center justify-center gap-2 bg-teal text-cream font-heading font-bold rounded-full py-3 border-2 border-charcoal shadow-brutsm">
        <MessageSquare className="w-5 h-5" /> Text
      </a>
    </div>
  );
}
